import { Trans } from '@lingui/macro';
import { ViewSidebar, Visibility } from '@mui/icons-material';
import { Box, Skeleton } from '@mui/material';
import { Suspense } from 'react';
import InterfaceTab from '../components/InterfaceTab';
import { VisibleUnitsTab } from '../components/VisibleUnitsTab';

export const useTabs = (organizationId: number | null) => {
  const tabs = [
    {
      id: 'visible-units',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <Visibility fontSize="small" />
          <Trans>Unidades visibles</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <VisibleUnitsTab organizationId={organizationId} />
        </Suspense>
      ),
    },
    {
      id: 'interface',
      label: (
        <Box display="flex" alignItems="center" gap={2}>
          <ViewSidebar fontSize="small" />
          <Trans>Interfaz</Trans>
        </Box>
      ),
      component: (
        <Suspense fallback={<Skeleton variant="rounded" height={400} />}>
          <InterfaceTab organizationId={organizationId} />
        </Suspense>
      ),
    },
  ];

  return tabs;
};
